import Choices, {type Item} from 'choices.js';

export interface ISelectData {
    name: string;
    value: string | string[] | Item | Item[];
}

interface ISelectOptions {
    onChange?(data: ISelectData): void;
    onInit?(data: ISelectData): void;
}

export class Select {
    private readonly parent: Element;
    private readonly container: Element | null;

    private readonly options: ISelectOptions;
    private readonly choicesInstance?: Choices;

    private readonly parentClass = 'select' as const;
    private readonly classes = {
        parent   : this.parentClass,
        container: `${this.parentClass}__container`,
        hide     : `${this.parentClass}--hide`
    } as const;

    constructor(parent: Element, options?: ISelectOptions) {
        this.parent = parent;
        this.options = {...options};

        this.container = this.parent.querySelector(`.${this.classes.container}`);

        if (this.container) {
            const optionsCount = this.container.querySelectorAll('option').length;

            if (optionsCount <= 1) {
                (this.parent as HTMLElement).classList.add(this.classes.hide);

                return;
            }
        }

        if (this.container) {
            this.choicesInstance = new Choices(this.container, {
                allowHTML     : true,
                shouldSort    : false,
                removeItems   : true,
                itemSelectText: '',
                searchEnabled : false,
                placeholder   : true,
                position      : 'bottom'
            });

            this.choicesInstance.passedElement.element.addEventListener('change', () => {
                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(this.getData());
                }
            });
        }

        if (this.options.onInit) {
            this.options.onInit(this.getData());
        }
    }

    getName(): ISelectData['name'] {
        if (this.container) {
            const name = this.container.getAttribute('name');

            return name ?? '';
        }

        return '';
    }

    getValue(): ISelectData['value'] {
        if (this.choicesInstance) {
            return this.choicesInstance.getValue(true);
        }

        return '';
    }

    getData(): ISelectData {
        const name = this.getName();
        const value = this.getValue();

        return {
            name,
            value
        };
    }
}
